function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { DeviceType } from '@sky-uk-ott/client-lib-js-device';
import deepmerge from 'deepmerge';
import { isRemoteConfigEnabled } from './core-video-config-types';
import { PlaybackType } from '../../core/player/playout-data';
import { version } from '../../version';
import { VideoColourSpace, VideoFormat } from '../../core/player/video-format';
import { sdkLogger } from '../../logger';
import { CvsdkError, ErrorSeverity } from '../../error';
import { adaptSdkAddonsClientConfig } from '../adapters/addons-config-adapter/addons-config-adapter';
import { adaptSdkPlayersClientConfig } from '../adapters/players-config-adapter/players-config-adapter';
import { checkForMatch } from './core-video-config-device-matcher-tester';
import { safeRequestIdleCallback } from '../../utils/safe-request-idle-callback';
import { promiseWithTimeout } from '../../utils/promise-utils';
import { RemoteConfigErrorCodes } from './core-video-config.enums';
export { RemoteConfigErrorCodes } from './core-video-config.enums';
export var CORE_VIDEO_CONFIG_VALUE_UNDEFINED = 'core-video-config-custom-undefined';
var REMOTE_CONFIG_REQUEST_TIMEOUT = 5000;
/**
 * Replace all CORE_VIDEO_CONFIG_VALUE_UNDEFINED string values with actual undefined
 * @param config
 * @returns
 */ export function fixUndefinedValues(config) {
    Object.keys(config).forEach(function(configKey) {
        var configValue = config[configKey];
        if (configValue && (typeof configValue === "undefined" ? "undefined" : _type_of(configValue)) === 'object') {
            fixUndefinedValues(configValue);
            return;
        }
        if (configValue === CORE_VIDEO_CONFIG_VALUE_UNDEFINED) {
            var typedKey = configKey;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Types are too complicated here for Typescript it seems
            config[typedKey] = undefined;
        }
    });
    return config;
}
export function mergeConfigs(c1, c2, onWarning) {
    var unionMergeWithWarning = function(parentConfigArray, newArray) {
        var isParentComparable = parentConfigArray.every(function(val) {
            return (typeof val === "undefined" ? "undefined" : _type_of(val)) !== 'object';
        });
        var isNewArrayComparable = newArray.every(function(val) {
            return (typeof val === "undefined" ? "undefined" : _type_of(val)) !== 'object';
        });
        if (isParentComparable && isNewArrayComparable) {
            // If there are elements in the merged array which do not exist in the new array
            // It means the new array is more restrictive. Since the array merge is a union,
            // more restrictive merges are not supported and could indicate an incorrectly
            // defined config
            var isNewArrayMoreRestrictive = parentConfigArray.some(function(val) {
                return !newArray.includes(val);
            });
            if (isNewArrayMoreRestrictive) {
                var message = "A sub-config tried to define a more restrictive array than its parent config which is not valid for union merging of arrays.\nThis likely indicates an incorrectly defined config.\n\nParent Config Array: [".concat(parentConfigArray.join(', '), "]\n\nSub-Config Config Array: [").concat(newArray.join(', '), "]\n");
                onWarning(message);
            }
        }
        var dedupedNewArray = newArray.filter(function(val) {
            return !parentConfigArray.includes(val);
        });
        return _to_consumable_array(parentConfigArray).concat(_to_consumable_array(dedupedNewArray));
    };
    var mergedConfig = deepmerge(c1, c2, {
        arrayMerge: unionMergeWithWarning
    });
    if ('deviceMatchers' in mergedConfig) {
        var c1Matchers = 'deviceMatchers' in c1 && Array.isArray(c1.deviceMatchers) ? c1.deviceMatchers : [];
        var c2Matchers = 'deviceMatchers' in c2 && Array.isArray(c2.deviceMatchers) ? c2.deviceMatchers : [];
        var mergedMatchers = _to_consumable_array(c1Matchers).concat(_to_consumable_array(c2Matchers));
        mergedConfig['deviceMatchers'] = mergedMatchers;
    }
    return mergedConfig;
}
export var CoreVideoConfigProvider = /*#__PURE__*/ function() {
    "use strict";
    function CoreVideoConfigProvider(sdkConfig, device, compiledConfigLoader) {
        _class_call_check(this, CoreVideoConfigProvider);
        _define_property(this, "sdkConfig", void 0);
        _define_property(this, "device", void 0);
        _define_property(this, "compiledConfigLoader", void 0);
        _define_property(this, "configPath", void 0);
        _define_property(this, "etag", void 0);
        _define_property(this, "coreVideoConfigPerPlaybackType", void 0);
        _define_property(this, "localCoreVideoConfigPerPlaybackType", void 0);
        _define_property(this, "requestConfigPromise", void 0);
        _define_property(this, "failoverReason", void 0);
        _define_property(this, "logger", void 0);
        this.sdkConfig = sdkConfig;
        this.device = device;
        this.compiledConfigLoader = compiledConfigLoader;
        this.logger = sdkLogger.withContext('Remote Config Provider');
        this.configPath = this.buildPath();
    }
    _create_class(CoreVideoConfigProvider, [
        {
            key: "initialise",
            value: function initialise() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_device_lifecycle_onResuming, _this_device_lifecycle, storedConfig, _this_buildPlaybackTypesConfig, playbackTypesConfig, appliedDeviceMatchers, coreVideoConfigPerPlaybackType, defaultConfigLoadError;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.failoverReason = RemoteConfigErrorCodes.Default;
                                (_this_device_lifecycle = _this.device.lifecycle) === null || _this_device_lifecycle === void 0 ? void 0 : (_this_device_lifecycle_onResuming = _this_device_lifecycle.onResuming) === null || _this_device_lifecycle_onResuming === void 0 ? void 0 : _this_device_lifecycle_onResuming.call(_this_device_lifecycle, /*#__PURE__*/ _async_to_generator(function() {
                                    return _ts_generator(this, function(_state) {
                                        safeRequestIdleCallback(function() {
                                            if (isRemoteConfigEnabled(_this.sdkConfig)) {
                                                return _this.refreshRemoteConfig(_this.sdkConfig);
                                            }
                                        });
                                        return [
                                            2
                                        ];
                                    });
                                }));
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                safeRequestIdleCallback(function() {
                                    if (isRemoteConfigEnabled(_this.sdkConfig)) {
                                        return _this.refreshRemoteConfig(_this.sdkConfig);
                                    }
                                });
                                return [
                                    4,
                                    _this.compiledConfigLoader(_this.configPath)
                                ];
                            case 2:
                                storedConfig = _state.sent();
                                // Remote Config will have additional identifiable information which we don't
                                // have when using the bundled default config.
                                storedConfig.configIdentifier = '@sky-uk-ott/core-video-sdk-core-video-config';
                                storedConfig.configTimestamp = "".concat(Date.now());
                                _this_buildPlaybackTypesConfig = _sliced_to_array(_this.buildPlaybackTypesConfig(storedConfig), 2), playbackTypesConfig = _this_buildPlaybackTypesConfig[0], appliedDeviceMatchers = _this_buildPlaybackTypesConfig[1];
                                coreVideoConfigPerPlaybackType = _this.mergePlaybackTypesConfig(storedConfig, playbackTypesConfig, appliedDeviceMatchers);
                                if (!_this.coreVideoConfigPerPlaybackType) {
                                    _this.coreVideoConfigPerPlaybackType = coreVideoConfigPerPlaybackType;
                                    _this.localCoreVideoConfigPerPlaybackType = deepmerge({}, _this.coreVideoConfigPerPlaybackType);
                                    _this.logger.verbose('Using default local config to set initial config values.');
                                } else if (!_this.localCoreVideoConfigPerPlaybackType) {
                                    _this.localCoreVideoConfigPerPlaybackType = coreVideoConfigPerPlaybackType;
                                    _this.logger.verbose('Remote config json already fetched, setting default local config only.');
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                defaultConfigLoadError = _state.sent();
                                _this.throwLocalConfigInitializationError(defaultConfigLoadError);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "throwLocalConfigInitializationError",
            value: function throwLocalConfigInitializationError(defaultConfigLoadError) {
                this.logger.error('Failed to load default config with error: ', defaultConfigLoadError);
                var error = CvsdkError.from({
                    code: 'REMOTE_CONFIG_INITIALISATION_FAILURE',
                    message: 'Failed to load default config',
                    severity: ErrorSeverity.Fatal,
                    cause: {
                        defaultConfigLoadError: defaultConfigLoadError
                    }
                });
                throw error;
            }
        },
        {
            key: "getConfig",
            value: function getConfig() {
                if (!this.coreVideoConfigPerPlaybackType) {
                    throw new Error('Tried to retrieve config before remote config provider was initialised');
                }
                return this.coreVideoConfigPerPlaybackType;
            }
        },
        {
            key: "getFailoverReason",
            value: function getFailoverReason() {
                return this.failoverReason;
            }
        },
        {
            key: "buildInternalConfig",
            value: function buildInternalConfig(playbackType, device) {
                if (!this.coreVideoConfigPerPlaybackType) {
                    throw new Error('Tried to retrieve config before remote config provider was initialised');
                }
                if (!this.localCoreVideoConfigPerPlaybackType) {
                    throw new Error('No default local config available for given device');
                }
                var coreVideoConfig = this.coreVideoConfigPerPlaybackType[playbackType] || this.coreVideoConfigPerPlaybackType.default;
                var localCoreVideoConfig = this.localCoreVideoConfigPerPlaybackType[playbackType] || this.localCoreVideoConfigPerPlaybackType.default;
                if (!coreVideoConfig || !localCoreVideoConfig) {
                    return;
                }
                var _this_sdkConfig = this.sdkConfig, addons = _this_sdkConfig.addons, players = _this_sdkConfig.players, telemetry = _this_sdkConfig.telemetry, csai = _this_sdkConfig.csai, cmcd = _this_sdkConfig.cmcd, performance = _this_sdkConfig.performance, reducedLatency = _this_sdkConfig.reducedLatency, prefetching = _this_sdkConfig.prefetching, metalist = _this_sdkConfig.metalist;
                var addonsConfig = adaptSdkAddonsClientConfig({
                    clientConfig: addons,
                    defaultConfig: localCoreVideoConfig.addons
                });
                var playersConfig = adaptSdkPlayersClientConfig({
                    defaultConfig: localCoreVideoConfig.players,
                    clientConfig: players
                }, device);
                var dynamicConfig = {
                    configMetadata: _object_spread({}, coreVideoConfig.configMetadata),
                    players: playersConfig,
                    addons: addonsConfig,
                    hasExtendedDvrSupport: localCoreVideoConfig.hasExtendedDvrSupport,
                    preferredStreamPropertyGroups: coreVideoConfig.preferredStreamPropertyGroups,
                    allowedDvrWindowDurations: localCoreVideoConfig.allowedDvrWindowDurations,
                    prefetching: prefetching,
                    telemetry: telemetry,
                    csai: csai,
                    cmcd: cmcd,
                    performance: performance,
                    metalist: metalist,
                    reducedLatency: reducedLatency,
                    allowedAudioCodecs: localCoreVideoConfig.allowedAudioCodecs,
                    drmOverride: localCoreVideoConfig.drmOverride
                };
                return dynamicConfig;
            }
        },
        {
            key: "checkHasConfigChanged",
            value: function checkHasConfigChanged(lastConfigIdentifier) {
                var _this_coreVideoConfigPerPlaybackType;
                var currentConfigIdentifier = (_this_coreVideoConfigPerPlaybackType = this.coreVideoConfigPerPlaybackType) === null || _this_coreVideoConfigPerPlaybackType === void 0 ? void 0 : _this_coreVideoConfigPerPlaybackType.default.configMetadata.configIdentifier;
                return lastConfigIdentifier !== currentConfigIdentifier;
            }
        },
        {
            key: "buildPath",
            value: function buildPath() {
                var lowerCaseDeviceType = this.device.type.toLowerCase();
                var lowerCaseDeviceModel = this.device.deviceInfo.deviceModel.toLowerCase();
                var lowerCaseProposition = this.sdkConfig.proposition.toLowerCase();
                return "".concat(version, "/").concat(lowerCaseProposition, "/").concat(lowerCaseDeviceType, "/").concat(this.device.type === DeviceType.Ion ? "".concat(lowerCaseDeviceModel, "/").concat(lowerCaseDeviceModel) : "".concat(lowerCaseDeviceType));
            }
        },
        {
            key: "buildPlaybackTypesConfig",
            value: function buildPlaybackTypesConfig(storedConfig) {
                var configWithUndefinedValues = fixUndefinedValues(storedConfig);
                return this.applyDeviceMatchers(configWithUndefinedValues, this.device.deviceInfo);
            }
        },
        {
            key: "mergePlaybackTypesConfig",
            value: function mergePlaybackTypesConfig(storedConfig, playbackTypesConfig, appliedDeviceMatchers) {
                var _this = this;
                var configMetadata = {
                    configIdentifier: storedConfig.configIdentifier,
                    configTimestamp: storedConfig.configTimestamp,
                    appliedDeviceMatchers: appliedDeviceMatchers,
                    cvsdkConfigVersionPath: this.configPath
                };
                var mergedConfig = {
                    default: _object_spread_props(_object_spread({}, playbackTypesConfig.default), {
                        preferredStreamPropertyGroups: this.adaptPreferredStreamPropertyGroups(playbackTypesConfig.default.preferredStreamPropertyGroups),
                        configMetadata: configMetadata
                    })
                };
                Object.keys(PlaybackType).forEach(function(playbackTypeKey) {
                    var playbackType = playbackTypeKey;
                    if (!playbackTypesConfig[playbackType]) {
                        return;
                    }
                    mergedConfig[playbackType] = _this.buildConfigForPlaybackType(playbackTypesConfig, configMetadata, playbackType);
                });
                return mergedConfig;
            }
        },
        {
            key: "buildConfigForPlaybackType",
            value: function buildConfigForPlaybackType(playbackTypesConfig, configMetadata, playbackType) {
                var _this = this;
                var playbackTypeConfig = playbackTypesConfig[playbackType];
                if (!playbackTypeConfig) {
                    return;
                }
                var mergedBaseConfig = mergeConfigs(playbackTypesConfig.default, playbackTypeConfig, function(msg) {
                    return _this.logger.warn(msg);
                });
                var mergedConfig = _object_spread_props(_object_spread({}, mergedBaseConfig), {
                    preferredStreamPropertyGroups: this.adaptPreferredStreamPropertyGroups(mergedBaseConfig.preferredStreamPropertyGroups),
                    configMetadata: _object_spread_props(_object_spread({}, configMetadata), {
                        appliedPlaybackTypeOverride: playbackType
                    })
                });
                return mergedConfig;
            }
        },
        {
            key: "adaptPreferredStreamPropertyGroups",
            value: function adaptPreferredStreamPropertyGroups(streamPropertyGroups) {
                return streamPropertyGroups === null || streamPropertyGroups === void 0 ? void 0 : streamPropertyGroups.map(function(group) {
                    return _object_spread_props(_object_spread({}, group), {
                        maxVideoFormat: VideoFormat[group.maxVideoFormat],
                        supportedColourSpaces: group.supportedColourSpaces.map(function(cs) {
                            return VideoColourSpace[cs];
                        })
                    });
                });
            }
        },
        {
            key: "refreshRemoteConfig",
            value: function refreshRemoteConfig(config) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_coreVideoConfigPerPlaybackType_default_configMetadata, _this_coreVideoConfigPerPlaybackType_default, _this_coreVideoConfigPerPlaybackType, storedConfig, error, _this_buildPlaybackTypesConfig, playbackTypesConfig, appliedDeviceMatchers;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.requestConfigPromise) {
                                    return [
                                        2,
                                        _this.requestConfigPromise
                                    ];
                                }
                                // set failoverReason while request in progress
                                _this.failoverReason = RemoteConfigErrorCodes.RequestInProgress;
                                _this.requestConfigPromise = _this.requestConfig(config);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    4,
                                    5
                                ]);
                                return [
                                    4,
                                    _this.requestConfigPromise
                                ];
                            case 2:
                                storedConfig = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                error = _state.sent();
                                if (_instanceof(error, CvsdkError)) {
                                    _this.failoverReason = error.code;
                                }
                                throw error;
                            case 4:
                                _this.requestConfigPromise = undefined;
                                return [
                                    7
                                ];
                            case 5:
                                if (!storedConfig) {
                                    return [
                                        2
                                    ];
                                }
                                if (storedConfig.configIdentifier === ((_this_coreVideoConfigPerPlaybackType = _this.coreVideoConfigPerPlaybackType) === null || _this_coreVideoConfigPerPlaybackType === void 0 ? void 0 : (_this_coreVideoConfigPerPlaybackType_default = _this_coreVideoConfigPerPlaybackType.default) === null || _this_coreVideoConfigPerPlaybackType_default === void 0 ? void 0 : (_this_coreVideoConfigPerPlaybackType_default_configMetadata = _this_coreVideoConfigPerPlaybackType_default.configMetadata) === null || _this_coreVideoConfigPerPlaybackType_default_configMetadata === void 0 ? void 0 : _this_coreVideoConfigPerPlaybackType_default_configMetadata.configIdentifier)) {
                                    return [
                                        2
                                    ];
                                }
                                _this_buildPlaybackTypesConfig = _sliced_to_array(_this.buildPlaybackTypesConfig(storedConfig), 2), playbackTypesConfig = _this_buildPlaybackTypesConfig[0], appliedDeviceMatchers = _this_buildPlaybackTypesConfig[1];
                                _this.coreVideoConfigPerPlaybackType = _this.mergePlaybackTypesConfig(storedConfig, playbackTypesConfig, appliedDeviceMatchers);
                                _this.logger.verbose('Using remote config json to set initial config values.');
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "requestConfig",
            value: function requestConfig(config) {
                var _this = this;
                return _async_to_generator(function() {
                    var baseUrl, url, encodedUrl, error, // TODO https://gspcloud.atlassian.net/browse/VPTJS-11707
                    // This error handling is not strictly correct.
                    // For example, if a device is offline, there’s a CORS or CSP issue, `fetch` fails immediately.
                    // By catching _any_ errors and rethrowing them as timeout errors we are misrepresenting what occurred.
                    fetchResult, status, error1, etag, parsedConfig, e, error2;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                baseUrl = "".concat(config.remoteConfigurationService.host, "/js");
                                url = "".concat(baseUrl, "/").concat(_this.configPath, "-config.json");
                                try {
                                    encodedUrl = encodeURIComponent(url);
                                    decodeURIComponent(encodedUrl);
                                } catch (e) {
                                    if (_instanceof(e, URIError) && e.message === 'URI malformed') {
                                        error = CvsdkError.from({
                                            code: RemoteConfigErrorCodes.MalformedUri,
                                            message: 'URI malformed',
                                            severity: ErrorSeverity.Warning
                                        });
                                        throw error;
                                    }
                                }
                                return [
                                    4,
                                    promiseWithTimeout(fetch(url), REMOTE_CONFIG_REQUEST_TIMEOUT).catch(function(requestTimeoutError) {
                                        var error = CvsdkError.from({
                                            code: RemoteConfigErrorCodes.RequestTimedOut,
                                            message: "Call to remote Config has exceeded ".concat(REMOTE_CONFIG_REQUEST_TIMEOUT, "ms"),
                                            severity: ErrorSeverity.Warning
                                        });
                                        throw error;
                                    })
                                ];
                            case 1:
                                fetchResult = _state.sent();
                                // reset failoverReason to default when response is successful
                                _this.failoverReason = RemoteConfigErrorCodes.Default;
                                status = fetchResult.status;
                                if (status >= 400) {
                                    error1 = CvsdkError.from({
                                        code: "".concat(RemoteConfigErrorCodes.HttpBadResponse).concat(status),
                                        message: "Remote CVSDK config request failed with status code ".concat(status),
                                        severity: ErrorSeverity.Warning
                                    });
                                    throw error1;
                                }
                                etag = fetchResult.headers.get('etag');
                                if (etag === _this.etag) {
                                    return [
                                        2
                                    ];
                                }
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    fetchResult.json()
                                ];
                            case 3:
                                parsedConfig = _state.sent();
                                if (Object.keys(parsedConfig).length === 0) {
                                    // set failoverReason when request in successful but with empty response
                                    _this.failoverReason = "".concat(RemoteConfigErrorCodes.SuccessfulEmptyResponse).concat(status);
                                    return [
                                        2
                                    ];
                                }
                                _this.etag = etag || undefined;
                                return [
                                    2,
                                    parsedConfig
                                ];
                            case 4:
                                e = _state.sent();
                                error2 = CvsdkError.from({
                                    code: "".concat(RemoteConfigErrorCodes.ParsingFailed).concat(status),
                                    message: "Remote CVSDK config request returned an invalid JSON with error ".concat(RemoteConfigErrorCodes.ParsingFailed).concat(status),
                                    severity: ErrorSeverity.Warning
                                });
                                throw error2;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "applyDeviceMatchers",
            value: function applyDeviceMatchers(config, deviceInfo) {
                var _this = this;
                // eslint-disable-next-line prefer-const -- What we really want here is deviceMatchers as const and newConfig as let, but JS doesn't provide an easy way to do that
                var deviceMatchers = config.deviceMatchers, newConfig = _object_without_properties(config, [
                    "deviceMatchers"
                ]);
                if (!deviceMatchers) {
                    return [
                        newConfig,
                        []
                    ];
                }
                var appliedMatchers = [];
                deviceMatchers.forEach(function(param) {
                    var matchers = param.matchers, deviceConfig = param.config, readableIdentifier = param.readableIdentifier;
                    var isDeviceMatch = checkForMatch(deviceInfo, matchers);
                    if (isDeviceMatch) {
                        appliedMatchers.push(readableIdentifier);
                        newConfig = mergeConfigs(newConfig, deviceConfig, function(msg) {
                            return _this.logger.warn(msg);
                        });
                    }
                });
                return [
                    newConfig,
                    appliedMatchers
                ];
            }
        }
    ]);
    return CoreVideoConfigProvider;
}();

//# sourceMappingURL=core-video-config-provider.js.map